export const LD_JSON_SCRIPT_TYPE = 'application/ld+json';

export const LD_JSON_HOMEPAGE_WEBSITE_METADATA = {
	'@context': 'https://schema.org/',
	'@type': 'Website',
	name: 'The Home Depot México',
	url: 'https://www.homedepot.com.mx',
	potentialAction: {
		'@type': 'SearchAction',
		target: 'https://www.homedepot.com.mx/s/{search_term_string}',
		'query-input': 'required name=search_term_string',
	},
};

export const LD_JSON_HOMEPAGE_CORPORATION_METADATA = {
	'@context': 'https://schema.org/',
	'@type': 'Corporation',
	url: 'https://www.homedepot.com.mx',
	name: 'The Home Depot México',
	logo: 'https://cdn.homedepot.com.mx/assets/img/logo_THD-01.svg',
	contactPoint: [
		{
			'@type': 'ContactPoint',
			telephone: '+52-800-004-6633',
			contactType: 'customer service',
			areaServed: 'MX',
			availableLanguage: 'Spanish',
		},
	],
	address: {
		'@type': 'PostalAddress',
		addressLocality: 'San Pedro Garza García',
		addressRegion: 'Nuevo León',
		addressCountry: 'México',
	},
};
